import { Client } from '@/utils';
import { architectureManagement as architectureManagementAPI } from '@/api';

const GET_TYPELIST = 'architectureManagement/GET_TYPELIST'; //获取组织类型
const GET_DEPARTMENTLIST = 'architectureManagement/GET_DEPARTMENTLIST'; //获取部门机构列表
const ADD_DEPART = 'architectureManagement/ADD_DEPART'; //新增部门、组织类型
const UPDATE_DEPART = 'architectureManagement/UPDATE_DEPART'; //编辑部门、组织类型
const DElETE_DEPART = 'architectureManagement/DElETE_DEPART'; //删除部门、组织类型

const GET_POSIDENTLIST = 'architectureManagement/GET_POSIDENTLIST'; //职级、标识列表
const GET_NEWPOSIDENTITEM = 'architectureManagement/GET_NEWPOSIDENTITEM'; //新增时获取一项新的职级、标识
const ADD_POSITION = 'architectureManagement/ADD_POSITION'; //职级-保存
const ADD_IDENTIFY = 'architectureManagement/ADD_IDENTIFY'; //新增标识-保存
const UNBIND_IDENTIFY = 'architectureManagement/UNBIND_IDENTIFY'; //标识解绑

const UPDATE_STORE_POSITIONLIST = 'architectureManagement/UPDATE_STORE_POSITIONLIST'; //更新职级列表store内的positionList
const UPDATE_STORE_IDENTFIYLIST = 'architectureManagement/UPDATE_STORE_IDENTFIYLIST'; //更新标识列表store内的positionList
const DELETE_STORE_POSITION = 'architectureManagement/DELETE_STORE_POSITION'; //删除职级列表store内的position
const DELETE_STORE_IDENTIFY = 'architectureManagement/DELETE_STORE_IDENTIFY'; //删除职级列表store内的identify


export default {
    state:{
        typeList:[],
        positionList:[],
        identifiyList:[],
        positionByDept:[],
        deptList:[],
        deptListByDept:[],
    },
    actions:{
        //获取组织类型
        async [GET_TYPELIST]({ commit }, {frontCode = '' } = {}) {
            commit(GET_TYPELIST, await Client.get(architectureManagementAPI.getTypeList,frontCode));
        },
        //获取部门机构列表
        async [GET_DEPARTMENTLIST]({ commit },{ params = {}, frontCode = '' } = {}) {
            commit(GET_DEPARTMENTLIST, {
                params:params,
                data:await Client.get(architectureManagementAPI.getDepartmentList,{ params },frontCode,false)
            });
        },
        //新增部门、组织类型
        async [ADD_DEPART]({ commit },{ data = {}, frontCode = '' } = {}) {
            commit(ADD_DEPART, await Client.post(architectureManagementAPI.addDepart,{ data },frontCode,true,true));
        },
        //编辑部门、组织类型
        async [UPDATE_DEPART]({ commit },{ data = {}, frontCode = '' } = {}) {
            commit(UPDATE_DEPART, await Client.post(architectureManagementAPI.updateDepart,{ data },frontCode,false,true));
        },
        //删除部门、部门类型
        async [DElETE_DEPART]({ commit },{ data = {}, frontCode = '' } = {}) {
            commit(DElETE_DEPART, await Client.post(architectureManagementAPI.delDepart,{ data },frontCode));
        },
        //职级、标识列表
        async [GET_POSIDENTLIST]({ commit },{ params = {}, frontCode = '' } = {}) {
            commit(GET_POSIDENTLIST, {
                params:params,
                data:await Client.get(architectureManagementAPI.getPosIdentList,{ params },frontCode,false)
            });
        },
        //新增时获取一项新的职级、标识
        async [GET_NEWPOSIDENTITEM]({ commit },{ data = {}, frontCode = '' } = {}) {
            commit(GET_NEWPOSIDENTITEM, {
                params:data,
                data:await Client.post(architectureManagementAPI.getNewPosIdentItem,{ data },frontCode,false)
            });
        },
        //职级-保存
        async [ADD_POSITION]({ commit },{ data = {}, frontCode = '' } = {}) {
            commit(ADD_POSITION, await Client.post(architectureManagementAPI.addPosition,{ data },frontCode,false));
        },
        //新增标识-保存
        async [ADD_IDENTIFY]({ commit },{ data = {}, frontCode = '' } = {}) {
            commit(ADD_IDENTIFY, await Client.post(architectureManagementAPI.addIdentifiy,{ data },frontCode,false));
        },
        
        //标识解绑
        async [UNBIND_IDENTIFY]({ commit },{ data = {}, frontCode = '' } = {}) {
            commit(UNBIND_IDENTIFY, await Client.post(architectureManagementAPI.unbindIdentify,{ data },frontCode,false));
        },

        //更新职级列表
        async [UPDATE_STORE_POSITIONLIST]({ commit },{ data = {} } = {}) {
            commit(UPDATE_STORE_POSITIONLIST, data);
        },

        //更新标识列表
        async [UPDATE_STORE_IDENTFIYLIST]({ commit },{ data = {} } = {}) {
            commit(UPDATE_STORE_IDENTFIYLIST, data);
        },

        //删除职级
        async [DELETE_STORE_POSITION]({ commit },{ data = {} } = {}) {
            commit(DELETE_STORE_POSITION, data);
        },

        //删除标识
        async [DELETE_STORE_IDENTIFY]({ commit },{ data = {} } = {}) {
            commit(DELETE_STORE_IDENTIFY, data);
        },

    },
    mutations:{
        //获取组织类型
        [GET_TYPELIST](state, data) {
            state.typeList = data;
        },
        //获取部门机构列表
        [GET_DEPARTMENTLIST](state, payload) {
            if(payload.params.deptId){
                state.deptListByDept = payload.data;
            }else{
                state.deptList = payload.data;
            }
        },
        //新增部门、组织类型
        [ADD_DEPART](state, data) {},
        //编辑部门、组织类型
        [UPDATE_DEPART](state, data) {},
        //删除部门、部门类型
        [DElETE_DEPART](state, data) {},

        //职级、标识列表
        [GET_POSIDENTLIST](state, payload) {
            if(payload.params.types == 1){ //职级
                state.positionList = payload.data.content?payload.data.content:[];
            }else if(payload.params.types == 2){ //标识
                state.identifiyList = payload.data.content?payload.data.content:[];
            }
        },
        //新增时获取一项新的职级、标识
        [GET_NEWPOSIDENTITEM](state, payload) {
            if(payload.params.types == 1){ //职级
                state.positionList.push(payload.data);
            }else if(payload.params.types == 2){ //标识
                state.identifiyList.push(payload.data);
            }
        },
        //职级-保存
        [ADD_POSITION](state, data) {},
       
        //新增标识-保存
        [ADD_IDENTIFY](state, data) {},

        //标识解绑
        [UNBIND_IDENTIFY](state,data){},

        //更新store内的positionList
        [UPDATE_STORE_POSITIONLIST](state, data) {
            state.positionList = JSON.parse(JSON.stringify(data.list));
        },

        //更新store内的identifiyList
        [UPDATE_STORE_IDENTFIYLIST](state, data) {
            state.identifiyList = JSON.parse(JSON.stringify(data.list));
        },

        //删除职级
        [DELETE_STORE_POSITION](state, data) {
            state.positionList.splice(data.index,1);
        },

        //删除标识
        [DELETE_STORE_IDENTIFY](state, data) {
            state.identifiyList.splice(data.index,1);
        },

    }
}



// WEBPACK FOOTER //
// ./src/store/modules/architectureManagement.js